import { RefreshCw, Trash2 } from "lucide-react";
import { useState } from "react";
import { Branch } from "@/services/backend/company/types/branch";
import { useDeleteBranchMutation } from "@/services/backend/company/api/branch";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";

export function DeleteBranchDialog({ branch }: { branch: Branch }) {
  const [open, setOpen] = useState(false);
  const [deleteBranch, { error, isLoading, isSuccess, reset }] =
    useDeleteBranchMutation();

  if (isSuccess) {
    reset();
    setOpen(false);
  }

  const doDelete = () => {
    if (isLoading) return;

    deleteBranch({ id: branch.id });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="destructive">
          <Trash2 className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t(`Niederlassung ${branch.name} wirklich löschen?`)}
          </DialogTitle>
          <DialogDescription>
            {t("Diese Aktion kann nicht rückgängig gemacht werden.")}
          </DialogDescription>
          <RTKQueryErrorAlert error={error} />
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline">{t("Abbrechen")}</Button>
            </DialogClose>
            <Button
              variant="destructive"
              disabled={isLoading}
              onClick={doDelete}
            >
              {isLoading && <RefreshCw className="mr-2 size-4" />}
              {t("Löschen")}
            </Button>
          </DialogFooter>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
